import { useQuery } from "@tanstack/react-query";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import { QUERY_KEYS } from "./querykeys";
import ApiRequest from "../ApiRequest";
import { requestURLs } from "@/Environment";

export interface TeamUnitType {
  id: string;
  name: string;
  parentId: string | null;
  type: "Top-level unit" | "Team";
  manager: string;
  managerId: string | null;
  resourcesCount: number;
  status: "Active" | "Inactive";
  description: string;
}

export type TeamUnitsResponseType = ResponseType<TeamUnitType[]>;

function useTeamUnitsQuery(organisationId: string, enabled = true) {
  return useQuery<
    AxiosResponseAndError<TeamUnitsResponseType>["response"],
    AxiosResponseAndError<TeamUnitsResponseType>["error"]
  >({
    queryKey: [QUERY_KEYS.teamUnits, organisationId],
    queryFn: async () =>
      await ApiRequest.get(`${requestURLs.resourceAdministrator}/team-units`),
    enabled: enabled && Boolean(organisationId),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

export default useTeamUnitsQuery;
